import React, { useState, useEffect } from "react";
import Footer from "../../views/layouts/footer";
import LeftSiderbar from "../../views/layouts/left-sidebar";
import SubHeader from "../../views/my_account/header";
import axios from "axios";
import {  AppImages, constant } from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import Header from "../../views/layouts/header";
import NoHistory from "./no-history";
import Nodata from "./nodatafound";
// class AccountSetting extends Component{
const AccountSetting = () => {
    // render() {
    const [title, setTitle] = useState("Dealerhop | LINK");
    const [shimmerEffect, setShimmerEffect] = useState("shimmerEffect");
    // const [isLoading, setIsLoading] = useState(false);
    const [applylink, setApplyLink] = useState("");
    const [sellLink, setSellLink] = useState("");
    const [isNoData, setIsNoData] = useState(true);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [dealerLogo, setDealerLogo] = useState("");

    useEffect(() => {
        setTimeout(() => {
            document.querySelector("body").scrollTo(0, 0);
        }, 100);
    }, []);

    useEffect(() => {
        getProfile();
        document.title = title;
    }, []);

	const handleShow = () => {
        navigator.clipboard.writeText(applylink);
        toast.success("Link copied", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

	const handleShowsell = () => {
        navigator.clipboard.writeText(sellLink);
        toast.success("Link copied", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };


    const getProfile = async () => {
        setShimmerEffect("shimmerEffect");
        // const USERTOKEN =  localStorage.getItem('user_token');
        axios({
            method: "GET",
            url: constant.GETDEALERLINK,
            headers: {
                Authorization: localStorage.getItem("user_token"),
            },
        })
            .then((response) => {
                if (response.data.status === true) {
                    // console.log(response.data)
                    setIsNoData(false);
                    setApplyLink(response.data.apply_link);
                    setSellLink(response.data.sell_link);
                    setDealerLogo(response.data.dealer_logo);
                
                }
                setShimmerEffect("");
            })
            .catch((error) => {
                setIsNoData(false);
                setShimmerEffect("");
                console.log("error call ", error);
            });
    };
    
    const [selectedImage, setSelectedImage] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
    
        if (file) {
          // Update the state with the selected image
          setSelectedImage(file);
        }
      };

      const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        handleImageUpload(event.target.files[0])
         
      };

      const handleImageUpload = async (selectedFile) => {
         
        setIsUploading(true);
        if (!selectedFile) {
          setIsUploading(false);
          toast.error("Please select an image to upload.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
          });
          return;
        }
      
        try {
          const formData = new FormData();
          formData.append("image", selectedFile);
        
          axios.post(constant.CHNAGEDEALERLOGO, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: localStorage.getItem('user_token')
              },
            }).then((response) => {
                   
                    if (response.data.status) {
                    //   console.log(response.data.dealer_logo)
                      setDealerLogo(response.data.dealer_logo);
                    //   toast.success(response.data.message, {
                    //       position: "top-right",
                    //       autoClose: 5000,
                    //       hideProgressBar: false,
                    //       closeOnClick: true,
                    //       pauseOnHover: true,
                    //       draggable: true,
                    //       progress: undefined,
                    //   });
                    
                    } else {
                      toast.error(response.data.message, {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                      });
                                           
                    }

                    setIsUploading(false);
                  })
                  .catch((error) => {    
                      setIsUploading(false);                 
                    throw error;
                  });              
         
        } catch (error) {
          console.error("Error uploading image:", error);
          setIsUploading(false);
        }
      };

    return (
        <>
            <Header />
            <div className="contentCoverbox setfooter_addclass">
                <LeftSiderbar />
                <div className="rightsidecontent">
                    <SubHeader />
                    <div className="myaccount_mandiv">
                        <div className="create_detailsbox">
                            <div className="create_innerboxdiv">
                                <div className="refer_textbox">
                                    <h3>Your Brand, Our Strategy</h3>
                                    <p>
                                    Upload your logo and take advantage of the high-intent quality of a
                                    Dealerhop lead form using the power of Two-Factor Authentication.
                                    </p>
                                </div>

                                <div className="account_inputbox">
                                
                              
                                    {/* <p className={shimmerEffect}>Dealer Logo</p> */}
                                 
                                </div>
                          
                            <div className="customelogo">
                                <input
                                id="file"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                            <label for="file">Click to uplod logo</label>
                          {}
                          {dealerLogo != "" ? (
                                               <img className={`greentik ${shimmerEffect}`} src={AppImages.greentik } />
                                            ) : null}
                            
                            </div>  


                                <div className="referral_linkbox setselltrade_box">
                                    <h3>Get Approved link:</h3>
                                    <p>
                                    Use the link below to generate Finance Leads using your
                                    website, social media profiles, and more.
                                    </p>
                                    <a onClick={handleShow} className={shimmerEffect} href="javascript:void(0)">                                        
                                        {applylink}
                                    </a>
                                </div>

                                <div className="referral_linkbox setselltrade_box">
                                    <h3>Sell/Trade link:</h3>
                                    <p>
                                    Use the link below to generate Sell/Trade Leads using your
                                    website, social media profiles, and more.
                                    </p>
                                    <a onClick={handleShowsell} className={shimmerEffect} href="javascript:void(0)">                                        
                                        {sellLink}
                                    </a>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
            <ToastContainer />
        </>
    );
    // }
};

export default AccountSetting;

const RefferalHistoryCell = (props) => {
    return (
        <ul>
            <li className="cmnwidthref">
                <span>{props?.item?.refer_date}</span>
            </li>
            <li className="cmnwidthmsg">
                <span>{props?.item?.message}</span>
            </li>
            <li className="cmnwidthamount">
                <span>${props?.item?.amount}</span>
            </li> 
                       
        </ul>
         
    );
};
